<template>
    <div class="edit-template-method">
        <!-- <form  @submit.stop.prevent v-if="!loading"> -->
        <div v-if="!loading">
            <div class="custom-row">
                <div>
                    <custom-input :inputType="'text'" v-if="selectedMethod.name" v-model="selectedMethod.name" :name="'selectedMethodName'" :label="$t('extra-variables.name')" :placeholder="$t('extra-variables.name')" :isDisabled="true"/>
                </div>
                <!-- <custom-input :inputType="'text'" v-model="varTypeModel" :name="'selectedMethodType'" :label="$t('extra-variables.type-label')" :placeholder="'Type..'" :isDisabled="true"/> -->
            </div>
           
            <custom-input :inputType="'text'" v-if="selectedMethod.expression " v-model="selectedMethodCopy.expression" :name="'selectedMethodExpression'" :label="'Expression'" :placeholder="'Expression..'" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'expression'"/>
  
            <custom-input :inputType="'text'" v-if="selectedMethod.if" v-model="selectedMethodCopy.if" :name="'exraVariableIfStatement'" :label="$t('extra-variables.if')" :placeholder=" $t('extra-variables.if') +'..'" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'if'"/>
            <custom-input :inputType="'text'" v-if="selectedMethod.then" v-model="selectedMethodCopy.then" :name="'exraVariableThenStatement'" :label="$t('extra-variables.then')" :placeholder="$t('extra-variables.then') + '..'" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'then'"/>
            <custom-input :inputType="'text'" v-if="selectedMethod.elseIf" v-model="selectedMethodCopy.elseIf" :name="'exraVariableElseIfStatement'" :label="$t('extra-variables.else-if')" :placeholder=" $t('extra-variables.else-if')+'..'" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'elseIf'"/>
            <custom-input :inputType="'text'" v-if="selectedMethod.elseIfThen" v-model="selectedMethodCopy.elseIfThen" :name="'exraVariableElseIfThenStatement'" :label="$t('extra-variables.then')" :placeholder=" $t('extra-variables.then')+'..'" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'elseIfThen'"/>
            <custom-input :inputType="'text'" v-if="selectedMethod.else" v-model="selectedMethodCopy.else" :name="'exraVariableElseStatement'" :label="$t('extra-variables.else')" :placeholder="$t('extra-variables.else-placeholder')" :optionBtn="true" :btnText="$t('extra-variables.add-var-btn')" @option-btn-clicked="$emit('get-variable-groups'), stagedInputField = 'else'"/>

            <div class="form-group" v-if="selectedMethod.type">
                <label for="formatType" :class="{'hide': !selectedMethodCopy.type}"  style="margin-bottom: 0; margin-top: 10px;">Output type</label>
                <select name="formatType" class="form-control selector" v-model="selectedMethodCopy.type" required> 
                    <option disabled value="">Output type</option>
                    <option value="Text">{{$t('extra-variables.text')}}</option>
                    <option value="Number">{{$t('extra-variables.number')}}</option>
                    <option value="List">{{$t('extra-variables.list')}}</option>
                    <option value="Timespan">{{$t('extra-variables.timespan')}}</option>
                </select>
            </div>
            
                <dictionary-adder v-if="selectedMethod.mappings && varType == 'Dictionary' " :selectedMethod="selectedMethod" :mappings="mappings" :focusInput="true"/>

            <div class="mappings" v-if="selectedMethod.mappings">
                <div class="mapping" v-for="(map, index) in mappings" :key="index" style="position:relative;"> 
                    <div class="row">
                        <custom-input class="col-lg-5 arrow" :inputType="'text'" v-model="map.string" :name="`mapString${index}`" :label="$t('extra-variables.if')" :placeholder="$t('extra-variables.if-placeholder')" />
                        <custom-input class="col-lg-6" :inputType="'text'" v-model="map.expression" :name="`mapExpression${index}`" :label="$t('extra-variables.then')" :placeholder="$t('extra-variables.then-placeholder')" />
                        
                        <button :disabled="undeleteable" type="button" class="btn col-lg-1" @click="removeMapping(map, index)"><img src="@/assets/svg/trash-button-no-circle.svg" /></button>
                        <div v-if="undeleteable" class="delete-alert"> <span class="text-danger">{{$t('extra-variables.undeleteable-msg')}}</span></div>    
                    </div>
                </div>
            </div>
        </div>
        <!-- </form> -->
    </div>
</template>
<script>
import CustomInput from "@/components/CustomInput";
import DictionaryAdder from "@/components/DictionaryAdder";
import EventBus from "@/assets/js/eventBus.js";
export default {
  name: "editTemplateMethod",
  data() {
        return {
            selectedMethodCopy: {},
            loading: true,
            stagedInputField: null,
            changesDetected: false,
            mappings: [],
            watchMappings: false,
            addMappingEntry: false,
        }
    },
    props: {
        selectedMethod: Object,
        varType: String
    },


    methods:{
    addToExpression(variable){
        if(this.selectedMethod.mappings && this.stagedInputField == 'expression'){   
            this.selectedMethodCopy[this.stagedInputField] = variable
        } else{
            this.selectedMethodCopy[this.stagedInputField] = this.selectedMethodCopy[this.stagedInputField] + variable
            this.stagedInputField = null
        }
        },
        onSave(){
            if(this.mappings){
                let formattedMapping = {}
                this.mappings.forEach(mapping => {
                    formattedMapping[mapping.string] = mapping.expression
                });
                this.selectedMethodCopy.mappings = formattedMapping
            }
            this.$emit('update-var', this.selectedMethodCopy)
            this.changesDetected = false
        },
        addToMappings(){
            let mapEntry = {
                string: this.newMap.string,
                expression: this.newMap.expression
            }
            //  this.mappings.push(mapEntry)
            this.mappings.splice(0, 0, mapEntry)
            this.newMap.string = ''
            this.newMap.expression = ''
            this.changesDetected = true
        },
        removeMapping(mapping, index){
            this.mappings.splice(index, 1)
            this.changesDetected = true
        },
        formatMappings(){
            if(this.selectedMethod.mappings){
                this.mappings = []
                this.changesDetected = false
                this.watchMappings = false
                Object.entries(this.selectedMethod.mappings).forEach(item => {
                    const mappingEntry = {
                        string: item[0],
                        expression: item[1],
                    }
                    this.mappings.push(mappingEntry)
                })
                this.$nextTick(()=> this.watchMappings = true)
            }
        },
        resetVariable(){
            this.changesDetected = false
        }
    },
    computed:{
        variableCategory(){
            return this.selectedMethod.name.includes('_') ? this.selectedMethod.name.substring(1, this.selectedMethod.name.lastIndexOf('_')).replaceAll('_', ' → ' ) : null
        },
        varTypeModel(){
            if(this.varType == 'Dictionary') return this.$t("extra-variables.dictionary")
            if(this.varType == 'If') return this.$t("extra-variables.if")
            else return this.varType
        },
        undeleteable(){
           if(this.varType == 'Dictionary' && this.mappings.length == 1) return true
           else return false
        }
        

    }, 
    created(){
        this.formatMappings()
        this.selectedMethodCopy = Object.assign({}, this.selectedMethod);
        // this.selectedMethodCopy = {...this.selectedMethod}
        this.loading = false
    },
    watch: {
        selectedMethod: {
            handler: function (val, oldVal) {
                this.formatMappings()
                this.selectedMethodCopy = null
                this.selectedMethodCopy = Object.assign({}, this.selectedMethod);
                // this.selectedMethodCopy = {...this.selectedMethod}
            }
        },
        selectedMethodCopy: {
            handler: function (val, oldVal) {
                if(JSON.stringify(this.selectedMethod) === JSON.stringify(this.selectedMethodCopy)) this.changesDetected = false
                else this.changesDetected = true
            }, deep: true
        },
            mappings: {
            handler: function (val, oldVal) {
                if(this.watchMappings == true) {
                    console.log("her")
                    this.changesDetected = true,
                    this.$emit('detect-changes')
                }
            }, deep: true
        },
        changesDetected: {
            handler: function (val, oldVal) {
                console.log("changes?")    
                if(this.changesDetected == true){
                    this.$emit('detect-changes')
                    console.log("send!")
                }
            }
        }
    },
    mounted(){
        EventBus.$on('add-to-expression', this.addToExpression)
        EventBus.$on('save-extra-variable', this.onSave)
        EventBus.$on('new-selected-variable', this.resetVariable)
    },
    destroyed(){
        EventBus.$off('new-selected-variable')
        EventBus.$off('save-extra-variable')
        EventBus.$off('add-to-expression')
    },
    components:{
        CustomInput,
        DictionaryAdder
    }
}
</script>

<style lang="less">
       .edit-template-method{
        background-color: #fff;
        margin: 12px;
        padding-bottom: 35px;
        .dictionary-group{
            display: flex;
            flex-direction: column;
            button{
                height: 36px;
                width: max-content;
                &:hover{
                 box-shadow: 5px 4px 4px 2px rgba(0, 0, 0, 0.25); 
                }
            }
        }

        .custom-row{
            display: grid;
            grid-template-columns: 1fr 1fr;
        }

        .delete-alert{
                display:none;
              
                       span{
                        visibility: hidden;
                        opacity: 0;
                        transition: 2s;
                       }
                     
                    }

        .mappings{
            .mapping{
                position: relative;
                padding: 0 12px 12px 12px;  
                button{
                    z-index: 1;
                    padding: 0;
                    margin-top: 30px;
                    padding-right: 10px;

                    &:hover + .delete-alert{
                        display: block;
                       
                      span{
                        visibility: visible;
                        box-shadow: 5px 4px 4px 2px rgba(0, 0, 0, 0.25); 
                        opacity: 1;
                        background-color: #fafafa;  
                        padding: 12px; 
                        transition: 2s;
                        position:absolute;
                        top:10px; 
                        right:30px;
                        z-index: 2;
                      }
                     
                    }
                }
            }
        }
        .arrow::after{
            content: "→";
            position: absolute;
            right: -8px;
            top: 40px;
        }
        .actions{
            float: right;
            button{
                margin: 10px 0px 10px 5px;
            }
            .btn-secondary{
                padding: 2px 12px;
            }
        }
   

       }

</style>


